export default __webpack_public_path__ + "static/media/mg-rebate.d165f5cf.webp";